// extracted by mini-css-extract-plugin
export default {"burger":"Burger_burger__WGh+W","open":"Burger_open__uz7tt","line":"Burger_line__D9Yjd"};